import { Button, Modal, StatusIconProtoProps, TextField } from '@nike/eds';
import { VisitorPass } from '../../../models/IVisitorPass';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { translations as ts } from './i18n';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { ResendEmail } from '../../../services/pass-service';

export interface Props {
  pass: VisitorPass | undefined;
  onDismiss: () => void;
  isResendVisible: boolean;
  setSnackbar: Dispatch<
    SetStateAction<{
      showSnack: boolean;
      message: string;
      snackStatus: StatusIconProtoProps['status'];
    }>
  >;
}
export const ResendEmailModal: FC<Props> = ({ pass, onDismiss, isResendVisible, setSnackbar }) => {
  const { i18nString } = useI18nContext();
  const [emailAddress, setEmailAddress] = useState<string>('');
  useEffect(() => {
    setEmailAddress(pass?.emailAddress || '');
  }, [pass]);
  const resendEmail = () => {
    ResendEmail(pass?.passId, pass?.emailAddress)
      .then(() => {
        onDismiss();
        setSnackbar({
          message: 'Email successfully resent',
          showSnack: true,
          snackStatus: 'success',
        });
      })
      .catch(() => {
        setSnackbar({ message: 'Error resending email', showSnack: true, snackStatus: 'error' });
      });
  };

  const footer = (
    <>
      <div className={`eds-flex eds-flex--justify-content-center txt_uppercase`}>
        <Button
          size="small"
          variant="primary"
          onClick={resendEmail}
          className="txt_uppercase"
          data-testid="resend-email"
        >
          {i18nString(ts.SPONSOR_RESEND)}
        </Button>
      </div>
      <div className={`eds-flex eds-flex--justify-content-center`}>
        Email may be in the junk/spam folder.
      </div>
      <div>If you use Gmail, the email may be in the promotions folder.</div>
    </>
  );
  const header = (
    <>
      <div
        data-testid="resend-email-header"
        className={`eds-flex eds-flex--justify-content-center modal_header`}
      >
        {i18nString(ts.SPONSOR_RESEND_EMAIL)}
      </div>
    </>
  );
  return (
    <>
      <Modal
        hideFade
        isOpen={isResendVisible}
        headerSlot={header}
        onDismiss={onDismiss}
        footerSlot={footer}
        id="resend-email"
        data-testid="resend-email-modal"
      >
        <TextField
          id="emailaddress"
          data-testid="email-address"
          label="Email Address"
          hideLabel={true}
          type="text"
          name="emailaddress"
          onChange={e => setEmailAddress(e.target.value)}
          value={emailAddress}
          placeholder="Email Address"
        />
      </Modal>
    </>
  );
};
